// extracted by mini-css-extract-plugin
export default {"checkbox":"_24668466"};